exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-pointer[data-v-5d416f07]{cursor:pointer}.cursor-pointer:hover strong[data-v-5d416f07]{text-decoration:underline;color:#007bff}", ""]);

// exports
